export default "__VITE_ASSET__FBuFB2al__"